app.controller("ParametersController", [
    "$scope", "$state", "$uibModal", "AuthService", "StaticData", "ConfirmModal", "toastr",
    function ($scope, $state, $uibModal, AuthService, StaticData, ConfirmModal, toastr) {
        $scope.format = "dd/MM/yyyy";

        AuthService.getUserData().then(function (data) {
            $scope.user = data;
            $scope.birthDate = new Date(data.birthDate);
        });

        StaticData.getItemsByKey("gender").then(function (gender) {
            $scope.gender = gender;
            $scope.genderMap = _.keyBy($scope.gender, '_id');
        });

        $scope.changePassword = function () {
            $uibModal.open({
                controller: "ChangePassWinController",
                templateUrl: _pb + 'parameters/changePasswordWindow.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return { };
                    }
                }
            }).result
                .then(function (result) {

                }, function () {
                });
        };

        $scope.changeMail = function () {
            $state.go('change-mail', { profile: 'rest' });
        };

        $scope.changeImage = function () {
            $uibModal.open({
                controller: "alertWindowController",
                templateUrl: _pb + 'parameters/alert-window.html',
                size: "md",
                backdrop: 'static',
            }).result
                .then(function (result) {

                }, function () {
                });
        };

        $scope.goAlerts = function () {
            $state.go('employee.parameters.alerts');
        };

        function fetchFreshProfile() {
            AuthService.restore().then(function () {
                AuthService.getUserData().then(function (userData) {
                    $scope.user = userData;
                });
            });
        }

        $scope.enableTwoFactor = function () {
            $uibModal.open({
                controller: "TwoFactorModalController",
                templateUrl: _pb + "parameters/two-factor-modal.html",
                size: "md",
                backdrop: 'static',
            }).result.then(function () {
                fetchFreshProfile();
            });
        }

        $scope.disableTwoFactor = function () {
            ConfirmModal.show({
                title: "ორდონიანი დაცვის გამორთვა",
                message: "ნამდვილად გსურთ ამ ოპერაციის შესრულება? ავტორიზაციისთვის დაგჭირდებათ სმს კოდის გამოყენება",
            }).result.then(function () {
                AuthService.disableTwoFactor($scope.user._id).then(function () {
                    toastr.success('ორდონიანი დაცვა გამორთულია');
                    fetchFreshProfile();
                }).catch(function () {
                    toastr.error('', 'ოპერაციის შესრულების დროს დაფიქსირდა ხარვეზი');
                });
            });
        }

        $scope.enableEmailNotification = function () {
            ConfirmModal.show({
                title: "მეილზე შეტყობინების ჩართვა",
                message: "ნამდვილად გსურთ, რომ შემომავალი დოკუმენტისას მეილზე გამოგეგზავნოთ შეტყობინება?",
            }).result.then(function () {
                AuthService.enableEmailNotification().then(function () {
                    toastr.success('მეილზე შეტყობინება ჩართულია');
                    fetchFreshProfile();
                }).catch(function () {
                    toastr.error('', 'ოპერაციის შესრულების დროს დაფიქსირდა ხარვეზი');
                });
            });
        }

        $scope.disableEmailNotification = function () {
            ConfirmModal.show({
                title: "მეილზე შეტყობინების ჩართვა",
                message: "ნამდვილად გსურთ, რომ შემომავალი დოკუმენტისას მეილზე აღარ გამოგეგზავნოთ შეტყობინება?",
            }).result.then(function () {
                AuthService.disableEmailNotification().then(function () {
                    toastr.success('მეილზე შეტყობინება გამორთულია');
                    fetchFreshProfile();
                }).catch(function () {
                    toastr.error('', 'ოპერაციის შესრულების დროს დაფიქსირდა ხარვეზი');
                });
            });
        }
    }
]);
